<div class="h-full" *ngIf="contractData">
  <p-panel [attr.aria-label]="'Plan cost panel'" styleClass="h-full" #panel [toggleable]="screenWidth <= 992" [(collapsed)]="collapsed" collapseIcon="pi pi-angle-down"
    expandIcon="pi pi-angle-up" [toggleButtonProps]="{
      'ariaLabel': 'Plan cost panel toggle button',
    }">
    <ng-template pTemplate="header">
      <div class="flex w-full align-items-center" [ngClass]="{ 'cursor-pointer': screenWidth <= 992 }"
        (click)="screenWidth <= 992 && (collapsed = !collapsed)">
        <h3 class="m-0">Costs</h3>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <ng-container *ngIf="contractData.baseContract as base">
        <app-cost-item *ngIf="showPlanCost"
          [cost]="isOfferApplicable ? base.offerDetails?.chargeAmount?.toString() ?? '' : base.chrgAmt.toString()"
          [yearCost]="totalPriceYear" 
          [hasSubTitle]="contractData.baseContract.paymentScheduleTypeCode === 'ANNUAL' ? false : true" 
          [isOfferApplicable]="isOfferApplicable" 
          [hasPerMonth]="contractData.baseContract.paymentScheduleTypeCode === 'ANNUAL' ? false : true"
          [showPerMonth]="true"
          [numberOfInstallments]="base.numberOfInstallments">
          Plan costs
        </app-cost-item>
      
        <div *ngIf="isOfferApplicable" class="mt-2">
          <app-cost-item [cost]="base.offerDetails?.newChargeAmount?.toString() ?? ''"
            [hasPerMonth]="contractData.baseContract.paymentScheduleTypeCode === 'ANNUAL' ? false : true"
            [showPerMonth]="true"
            [numberOfInstallments]="base.numberOfInstallments">Discounted price*</app-cost-item>
        </div>
        <div class="mt-2">
          <app-cost-item [cost]="base.deductible">Repair deductible</app-cost-item>
        </div>
        <div *ngIf="base.replacementDeductible" class="mt-2">
          <app-cost-item  [cost]="base.replacementDeductible">Replacement
            deductible</app-cost-item>
        </div>
      </ng-container>
      <p-divider *ngIf="(!isPlanBYOP && !isPlanCe) || hidePlanPrice?.hideFlag"></p-divider>
      <ul class="mx-0 pl-2 text-sm text-slate-500">
        <li *ngIf="!isPlanBYOP && !isPlanCe" class="mb-2">{{ deductibleText }}</li>
      
        <li *ngIf="hidePlanPrice?.hideFlag" class="mb-2">
          {{ getPaymentText() }}
        </li>
      
        <li *ngIf="isOfferApplicable" class="mb-2">
          (*) Cannot be combined with any other offer. One offer per customer, per current contract year.
        </li>
      
        <li *ngIf="contractData.baseContract.surchargeDisclosure" class="mb-2">
          {{ contractData.baseContract.surchargeDisclosure }}
        </li>
      </ul>
    </ng-template>
  </p-panel>
</div>